import { getFeeForMatterValue } from '../services/services';
import {
  MATTER_VALUE_CHANGED,
  CLIENT_OR_SUBJECT_OF_MATTER_VALUE_CHANGED,
  NUMBER_OF_CLIENTS_CHANGED,
  NUMBER_OF_Opponents_CHANGED,
  NUMBER_OF_VALUE_ADDED_TAX_CHANGED,
  EXTRA_JUDICIAL_VV2300_CHANGED,
  EXTRA_JUDICIAL_VV1008_CHANGED,
  EXTRA_JUDICIAL_VV1000_CHANGED,
  EXTRA_JUDICIAL_VV7001_7002_CHANGED,
  JUDICIAL_MATTERS_ACTIVATION_CHANGED,
  EXTRA_JUDICIAL_MATTERS_ACTIVATION_CHANGED,
  JUDICIAL_VV1000_CHANGED,
  JUDICIAL_VV1008_CHANGED,
  JUDICIAL_VV3100_CHANGED,
  JUDICIAL_VV3104_CHANGED,
  JUDICIAL_VV7001_7002_CHANGED,
  JUDICIAL_VV7000_7003_CHANGED,
  JUDICIAL_ANRECHNUNG_CHANGED,
} from '../actions/index';

const initialState = {
  clientOrSubjectOfMatter: undefined,
  matterValue: undefined,
  numberOfClients: 1,
  numberOfOpponents: 1,
  extraJudical: true,
  judical: false,
  valueAddedTax: 19,
  sumExtraJudicial: 0,
  sumJudicial: 0,
  sum: 0,
  extraJudicialIsActive: true,
  judicialIsActive: false,
  feeMattersExtraJudicial: [
    {
      ziff: 'VV2300',
      kurzbezeichnung: 'Geschäftsgebühr',
      titel: 'Gebühr für die Prüfung der Erfolgsaussicht eines Rechtsmittels, soweit in Nummer 2102 nichts anderes bestimmt ist',
      type: 'fee',
      kommentar: 'Geschäftsgebühr, §§ 2, 13, 14 RVG i.V.m. Nr. 2300 VV RVG',
      Min: 0.5,
      Max: 2.5,
      isSetted: 1.3,
      sum: undefined,
    },
    {
      ziff: 'VV1000',
      kurzbezeichnung: 'Einigungsgebühr',
      titel: 'Einigungsgebühr',
      type: 'fee',
      kommentar: 'Einigungsgebühr, Nr. 1000 VV RVG',
      Min: 1.5,
      Max: 1.5,
      isSetted: undefined,
      sum: undefined,
    },
    {
      ziff: 'VV1008',
      kurzbezeichnung: 'Erhöhungsgebühr',
      titel: '',
      type: 'fee',
      kommentar: 'Erhöhungsgebühr, Nr. 1008 VV RVG',
      Min: 0.5,
      Max: 2.5,
      isSetted: undefined,
      sum: undefined,
    },
    {
      ziff: 'VV7001,7002',
      kurzbezeichnung: 'Auslagen',
      titel: 'Auslagen  ',
      type: 'amount',
      kommentar: 'Auslagen und Telekommunikationspauschale, Nr. 7001, 7002 VV RVG',
      Min: 0,
      Max: 50000,
      isSetted: undefined,
      sum: undefined,
    },
  ],
  feeMattersJudicial: [
    {
      ziff: 'Anrechnung',
      kurzbezeichnung: '',
      titel: '',
      type: 'fee',
      kommentar: 'Anrechnung der Geschäftsgebühr, Vorb. 3 IV 3 VV RVG',
      Min: -0.75,
      Max: 0,
      isSetted: undefined,
      sum: undefined
    },

    {
      ziff: 'VV3100',
      kurzbezeichnung: 'Verfahrensgebühr',
      titel: '',
      type: 'fee',
      kommentar: 'Verfahrensgebühr, Nr. 3100 VV RVG',
      Min: 0.5,
      Max: 2.5,
      isSetted: 1.3,
      sum: undefined,

    },
    {
      ziff: 'VV3104',
      kurzbezeichnung: 'Terminsgebühr',
      titel: '',
      type: 'fee',
      kommentar: 'Terminsgebühr, Nr. 3104 RVG',
      Min: 0.5,
      Max: 2.5,
      isSetted: 1.2,
      sum: undefined,
    },

    {
      ziff: 'VV1000',
      kurzbezeichnung: 'Einigungsgebühr',
      titel: 'Einigungsgebühr',
      type: 'fee',
      kommentar: 'Einigungsgebühr, Nr. 1000 VV RVG',
      Min: 1.5,
      Max: 1.5,
      isSetted: '0',
      sum: undefined,
    },
    {
      ziff: 'VV1008',
      kurzbezeichnung: 'Erhöhungsgebühr',
      titel: '',
      type: 'fee',
      kommentar: 'Erhöhungsgebühr, Nr. 1008 VV RVG',
      Min: 0.5,
      Max: 2.5,
      isSetted: '0',
      sum: undefined,
    },
    {
      ziff: 'VV7001,7002',
      kurzbezeichnung: 'Auslagen',
      titel: 'Auslagen  ',
      type: 'amount',
      kommentar: 'Auslagen und Telekommunikationspauschale, Nr. 7001, 7002 VV RVG',
      Min: 0,
      Max: 50000,
      isSetted: 0,
      sum: 0,
    },
    {
      ziff: 'VV7000,7003ff.',
      kurzbezeichnung: 'sonst. Kosten',
      titel: '  ',
      type: 'amount',
      kommentar: 'Sonstige Kosten, Nr. 7000,7003ff. VV RVG',
      Min: 0,
      Max: 50000,
      isSetted: 0,
      sum: 0,
    },
  ],
};
export default function (state = initialState, action) {
  console.log(action);
  switch (action.type) {
    case MATTER_VALUE_CHANGED:
    return   Object.assign({}, state, {
      matterValue: action.payload,
      sum: calculateSum(action.payload),
      feeMattersExtraJudicial: updateFeeMattersSums(calculateSum(action.payload), state.feeMattersExtraJudicial),
      feeMattersJudicial: updateFeeMattersSums(calculateSum(action.payload), state.feeMattersJudicial)
    });

    case CLIENT_OR_SUBJECT_OF_MATTER_VALUE_CHANGED:
    console.log(action.payload)
    return Object.assign({}, state, { clientOrSubjectOfMatter: action.payload});
    case NUMBER_OF_CLIENTS_CHANGED:
    return Object.assign({}, state, { numberOfClients: action.payload,
      feeMattersExtraJudicial : adaptErhöhungsgebührExtraJudicial(state,action.payload),
      feeMattersJudicial: adaptErhöhungsgebührJudicial(state,action.payload)
    })
    case NUMBER_OF_Opponents_CHANGED:
    return Object.assign({}, state, { numberOfOpponents: action.payload });
    case NUMBER_OF_VALUE_ADDED_TAX_CHANGED:
      return Object.assign({}, state, { valueAddedTax: action.payload });
    case EXTRA_JUDICIAL_VV2300_CHANGED:
      const activateOrDeactivate = (state.judicialIsActive && state.extraJudicialIsActive);
      state = updateExtraJudcicial(action, state, 'VV2300');
      return activateJudicalAnrechnung(state, activateOrDeactivate);
    case EXTRA_JUDICIAL_VV1008_CHANGED:
      return updateExtraJudcicial(action, state, 'VV1008');
    case EXTRA_JUDICIAL_VV7001_7002_CHANGED:
      return updateExtraJudcicialVV7001_7002(action, state);
    case EXTRA_JUDICIAL_VV1000_CHANGED:
      return updateExtraJudcicial(action, state, 'VV1000');
    case JUDICIAL_MATTERS_ACTIVATION_CHANGED:
      console.log(action.payload);
    //evaluates to true or false
      state = activateJudicalAnrechnung(state, action.payload && state.extraJudicialIsActive);
      //debugger;
    return Object.assign({}, state, { judicialIsActive: action.payload });
    case EXTRA_JUDICIAL_MATTERS_ACTIVATION_CHANGED:
      state = activateJudicalAnrechnung(state, action.payload && state.judicialIsActive)
      return Object.assign({}, state, {
        extraJudicialIsActive: action.payload,
        feeMattersExtraJudicial : adaptErhöhungsgebührExtraJudicial(state, state.numberOfClients),
      });
    case JUDICIAL_VV7001_7002_CHANGED:
    return updateJudcicialVV7001_7002(action, state)
    case JUDICIAL_ANRECHNUNG_CHANGED:
    return updateJudicalAnrechnung(action, state)
    case JUDICIAL_VV7000_7003_CHANGED:
    return updateJudcicialVV7000_7003(action, state)
    case JUDICIAL_VV1000_CHANGED:
    return updateJudcicial(action, state, 'VV1000')
    case JUDICIAL_VV1008_CHANGED:
    return updateJudcicial(action, state, 'VV1008')
    case JUDICIAL_VV3100_CHANGED:
    return updateJudcicial(action, state, 'VV3100')
    case JUDICIAL_VV3104_CHANGED:
    return updateJudcicial(action, state, 'VV3104')

    default:
    return state
  }
}

function adaptErhöhungsgebührExtraJudicial(state, numberOfClients) {
  function clamp(feeFactor) {
    return feeFactor <= 2 ?  feeFactor :  2;
  }
  return state.feeMattersExtraJudicial.map((matter) => {
    // debugger;
    if (matter.ziff !== 'VV1008') return matter
    matter.isSetted = clamp((numberOfClients -1) * 0.3)
    return matter
  })
}
function adaptErhöhungsgebührJudicial(state, numberOfClients) {
  function clamp(feeFactor) {
    return feeFactor <= 2 ?  feeFactor :  2;
  }
  return state.feeMattersJudicial.map((matter) => {

    if (matter.ziff === 'VV1008')
    matter.isSetted = clamp((numberOfClients -1) * 0.3)
    return matter
  });
}

function updateExtraJudcicial(action, state, vvnumber) {
  let feeMattersExtraJudicial = updateFeeMattersForSettingFee(state.feeMattersExtraJudicial, vvnumber, action.payload);
  feeMattersExtraJudicial = updateFeeMattersSums(calculateSum(state.matterValue), feeMattersExtraJudicial);
  return Object.assign({}, state, {feeMattersExtraJudicial: feeMattersExtraJudicial });
}
function updateJudcicial(action, state, vvnumber) {
  let feeMattersJudicial = updateFeeMattersForSettingFee(state.feeMattersJudicial, vvnumber, action.payload)
  feeMattersJudicial = updateFeeMattersSums(calculateSum(state.matterValue), feeMattersJudicial)
  return Object.assign({}, state, { feeMattersJudicial: feeMattersJudicial });
}
function updateExtraJudcicialVV7001_7002(action, state) {
  let feeMattersExtraJudicial = state.feeMattersExtraJudicial.map((feeMatter) => {
    if (feeMatter.ziff !== "VV7001,7002" || !isFinite(action.payload)) return feeMatter
    feeMatter.isSetted = action.payload
    feeMatter.sum = action.payload
    return feeMatter;
  })
  feeMattersExtraJudicial = updateFeeMattersSums(calculateSum(state.matterValue), feeMattersExtraJudicial)
  return Object.assign({}, state, { feeMattersExtraJudicial: feeMattersExtraJudicial });
}

function updateJudcicialVV7001_7002(action, state) {
  let feeMattersJudicial = state.feeMattersJudicial.map((feeMatter) => {
    if (feeMatter.ziff !== "VV7001,7002" || !isFinite(action.payload)) return feeMatter
    feeMatter.isSetted = action.payload
    feeMatter.sum = action.payload
    return feeMatter;
  })
  feeMattersJudicial = updateFeeMattersSums(calculateSum(state.matterValue), feeMattersJudicial)
  return Object.assign({}, state, { feeMattersJudicial: feeMattersJudicial });
}

function activateJudicalAnrechnung(state, activate) {
  let feeMattersJudicial = state.feeMattersJudicial.map((feeMatter) => {
    if (feeMatter.ziff !== "Anrechnung") return feeMatter;
    if (!activate) {
      feeMatter.isSetted = undefined;
      feeMatter.sum = undefined;
    } else {
      const geschaeftsgebuer = state.feeMattersExtraJudicial.find((item) => { return item.ziff == 'VV2300';});
      const anrechnungsgebuehr = Math.max(geschaeftsgebuer.isSetted * 0.5 * -1, -0.75);
      feeMatter.isSetted = anrechnungsgebuehr;
      feeMatter.sum = anrechnungsgebuehr;
    }
    return feeMatter;
  });
  feeMattersJudicial = updateFeeMattersSums(calculateSum(state.matterValue), feeMattersJudicial)
  return Object.assign({}, state, { feeMattersJudicial: feeMattersJudicial });
}

function updateJudicalAnrechnung(action, state) {
  let feeMattersJudicial = state.feeMattersJudicial.map((feeMatter) => {
    if (feeMatter.ziff != "Anrechnung" || !isFinite(action.payload)) return feeMatter;
    const anrechnungsgebuehr = action.payload
    if (anrechnungsgebuehr < -0.75) {
      feeMatter.isSetted = -0.75;
      feeMatter.sum = -0.75;
      return feeMatter
    }
    if (anrechnungsgebuehr > 0 || !anrechnungsgebuehr) {
      feeMatter.isSetted = 0;
      feeMatter.sum = 0
      return feeMatter;
    }
    feeMatter.isSetted = action.payload;
    feeMatter.sum = action.payload;
    return feeMatter;
  });
  feeMattersJudicial = updateFeeMattersSums(calculateSum(state.matterValue), feeMattersJudicial)
  return Object.assign({}, state, { feeMattersJudicial: feeMattersJudicial });
}

function updateJudcicialVV7000_7003(action, state) {
  let feeMattersJudicial = state.feeMattersJudicial.map((feeMatter) => {
    if (feeMatter.ziff != "VV7000,7003ff." || !isFinite(action.payload)) return feeMatter
    feeMatter.isSetted = action.payload
    feeMatter.sum = action.payload
    return feeMatter;
  });
  feeMattersJudicial = updateFeeMattersSums(calculateSum(state.matterValue), feeMattersJudicial)
  return Object.assign({}, state, { feeMattersJudicial: feeMattersJudicial });
}

function updateFeeMattersForSettingFee(feeMattersArr, feeZiff, toBeSettedFeeFactor,) {
  return feeMattersArr.map((feeMatter) => {
    if (feeMatter.ziff === feeZiff) feeMatter.isSetted = toBeSettedFeeFactor
    return feeMatter;
  })

}

function updateFeeMattersSums(feeForMatterValue, feeMattersArr) {
  return feeMattersArr.map(feeMatter => {
    if (feeMatter.type === 'fee') feeMatter.sum = (feeMatter.isSetted * feeForMatterValue)
    return feeMatter;
  })
}

function calculateSum(matterValue) {
  if (matterValue)
  return getFeeForMatterValue(matterValue);
  return 0;
}



// WEBPACK FOOTER //
// ./src/reducers/feeCalculation.js